module.exports = __webpack_public_path__ + "media/images/icons/gf-mod-zoom_in-sharp-69dadd63f28ce17c1ec69dd8818e58e1.svg";